import { makeStyles } from '@mui/styles';

export default makeStyles({
  button: {
    width: '100%',
    background: '#007bff',
  },
});
